import React, { PropTypes } from 'react';
import SpecialComponent from './_SpecialComponent';

const Special = ({ value }) => {
  const component = (typeof value === 'string' && value) || (value && value.component) || '"component:" missing';
  const size = require('styleTools/SizeClasses.scss');
  const sizeClass = (value && value.storlek && size[value.storlek]) || size.l;
  return (
    <div className={sizeClass}>
      <SpecialComponent component={component} value={value}/>
    </div>
  );
};

Special.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object
  ])
};

export default Special;



/** WEBPACK FOOTER **
 ** ./~/eslint-loader!./src/components/Page/PageComponents/Special/Special.js
 **/